import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
	isPossiblePhoneNumber,
	parsePhoneNumber,
} from 'react-phone-number-input'
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { InputField } from '../../../components/InputField'
import { SingleSignOn } from '../../../components/SingleSignOn'
import { countries } from '../../../constants'
import { useAuth, useMain } from '../../../hooks'
import a from '../../../styles/Account.module.css'
import i from '../../../styles/InputField.module.css'
import s from '../../../styles/Shared.module.css'
import { cf } from '../../../utils'

const UpdateUser = () => {
	const navigate = useNavigate()
	const [requestBody, setRequestBody] = useState({})
	const [phone, setPhone] = useState(undefined)
	const [isDisabled, setIsDisabled] = useState(true)
	const { setBigText, setSmallText, startWaiting, stopWaiting, alertThis } = useMain()
	const { update, missingInfo = {} } = useAuth()
	const [genderOptions] = useState([
		{ value: 'male', label: 'Male' },
		{ value: 'female', label: 'Female' },
		{ value: 'non-binary', label: 'Non-binary' },
		{ value: 'self-defined', label: 'Self-defined' },
	])

	useEffect(() => {
		if (!Object.keys(missingInfo).length) {
			navigate('/404')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const {
		mFirstName = true,
		mLastName = true,
		mPhone = true,
		mCountry = true,
		mEmail = true,
		mGender = true,
	} = missingInfo

	const { control, handleSubmit } = useForm()

	const handler = async (e) => {
		const name = e.target.name
		let value = e.target.value

		const validatorObj = {
			email: true,
			firstName: true,
			lastName: true,
		}

		switch (name) {
			case 'password':
				// TODO Update functionality
				setRequestBody((e) => ({
					...e,
					[name]: value,
				}))
				break
			case 'remember':
				setRequestBody((x) => ({
					...x,
					[name]: e.target.checked,
				}))
				break
			default:
				if (validatorObj[name])
					setRequestBody((e) => ({
						...e,
						[name]: value,
					}))
				break
		}
	}

	const genderHandler = (x) =>
		setRequestBody((e) => ({
			...e,
			gender: x,
		}))

	const handleSubmitHandler = async (e) => {
		e.preventDefault()
		startWaiting()
		let i = 0
		const keys = Object.keys(requestBody)
		const length = keys.length,
			reqBody = {}
		for (i; i < length; i++) {
			const el = requestBody[keys[i]]
			if (typeof el === 'object' && el.hasOwnProperty('value')) {
				reqBody[keys[i]] = el.value
			} else {
				reqBody[keys[i]] = el
			}
			if (Array.isArray(el)) {
				reqBody[keys[i]] = []
				let o = 0
				const keys_ = Object.keys({ label: true, value: true })
				const length = keys_.length
				for (o; o < length; o++) {
					if (typeof el[o] === 'object' && el[o].hasOwnProperty('value')) {
						reqBody[keys[i]].push(el[o].value)
					}
				}
			}
		}
		const res = await update(reqBody)
		if (!res.success)
			alertThis({
				message: res.message,
				forConfirmation: false,
				canClear: false,
			})
		stopWaiting()
	}

	useEffect(() => {
		setBigText((x) => 'Get up to 26% on your investment')
		setSmallText(
			(x) =>
				`By investing and diligently tracking your earnings, you can work towards building a more secure financial future.`
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		setRequestBody((x) => ({
			...x,
			phoneNumber: phone,
		}))
		if (phone) {
			const phoneNumber = parsePhoneNumber(phone)
			setRequestBody((x) => ({
				...x,
				country: phoneNumber ? countries[phoneNumber.country] : x.country,
			}))
		}
	}, [phone])

	useEffect(() => {
		setIsDisabled(
			(x) =>
				!(
					(mPhone || mCountry
						? requestBody['phoneNumber'] &&
						  isPossiblePhoneNumber(requestBody['phoneNumber'])
						: true) &&
					(mLastName ? requestBody['lastName'] : true) &&
					(mFirstName ? requestBody['firstName'] : true) &&
					(mCountry || mPhone ? requestBody['country'] : true) &&
					(mEmail ? requestBody['email'] : true) &&
					(mGender ? requestBody['gender'] : true)
				)
		)
	}, [mCountry, mEmail, mFirstName, mLastName, mPhone, mGender, requestBody])

	return (
		<div className={cf(s.flex, s.flexCenter, a.accountChild)}>
			<h1 className={cf(s.wMax, s.tLeft, s.m0, s.p0, a.theme)}>
				Create Account
			</h1>

			<div className={cf(s.wMax, s.flex, s.flexCenter, a.ssoParent)}>
				{/* <SingleSignOn
					login={false}
					type={'microsoft'}
				/> */}
				<SingleSignOn
					login={false}
					type={'google'}
					fill={true}
					greyed={true}
				/>
				{/* <SingleSignOn
					login={false}
					type={'apple'}
				/> */}
			</div>

			<div className={cf(s.wMax, s.flex, s.flexCenter, s.p_relative, a.orCon)}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='482'
					height='2'
					viewBox='0 0 482 2'
					fill='none'
					className={cf(s.wMax, s['p_absolute'], a.orStrike)}
				>
					<path
						d='M0 1L482 1.00004'
						stroke='#B2B2B2'
						strokeWidth='0.5'
					/>
				</svg>
				<span className={cf(s.flex, s.flexCenter, a.orTxtCon)}>
					<span className={cf(s.flex, a.orTxt)}>Add missing information</span>
				</span>
			</div>

			<form
				className={cf(s.wMax, s.flex, s.flexCenter, a.form)}
				onSubmit={(e) => handleSubmit(handleSubmitHandler(e))}
			>
				<div
					className={cf(
						s.wMax,
						s.flex,
						s.flex_dColumn,
						s.flexCenter,
						a.inputFieldCon
					)}
				>
					<div
						className={cf(
							s.wMax,
							s.flex,
							s.spaceXBetween,
							s.spaceYCenter,
							a.miniCon
						)}
					>
						{mFirstName ? (
							<InputField
								tag={'firstName'}
								state={requestBody}
								handler={handler}
								type={'text'}
								placeholder={'First Name'}
								mini={mLastName}
							/>
						) : (
							<></>
						)}
						{mLastName ? (
							<InputField
								tag={'lastName'}
								state={requestBody}
								handler={handler}
								type={'text'}
								placeholder={'Last Name'}
								mini={mFirstName}
							/>
						) : (
							<></>
						)}
					</div>
					{mGender ? (
						<InputField
							tag={'gender'}
							state={requestBody}
							handler={genderHandler}
							type={'select'}
							selectOptions={genderOptions}
							placeholder={'Gender'}
						/>
					) : (
						<></>
					)}
					{mPhone || mCountry ? (
						<PhoneInputWithCountry
							placeholder={'Enter phone number'}
							value={phone}
							name={'phoneNumber'}
							onChange={setPhone}
							className={cf(s.wMax, i.label)}
							control={control}
							rules={{ required: true, validate: isPossiblePhoneNumber }}
						/>
					) : (
						<></>
					)}
					{mEmail ? (
						<InputField
							tag={'email'}
							state={requestBody}
							handler={handler}
							type={'email'}
							placeholder={'Johntrey@gmail.com'}
						/>
					) : (
						<></>
					)}
				</div>

				<button
					type={'submit'}
					className={cf(
						s.wMax,
						s.flex,
						s.flexCenter,
						a.submitBtn,
						!isDisabled ? s.shadow : '',
						isDisabled ? cf(a.proceedDisabled, s.pointerDisabled) : ''
					)}
					disabled={isDisabled}
				>
					{isDisabled
						? (
								mPhone || mCountry
									? requestBody['phoneNumber'] &&
									  !isPossiblePhoneNumber(requestBody['phoneNumber'])
									: false
						  )
							? 'Phone number invalid'
							: 'Fill the form'
						: 'Continue'}
				</button>

				<div
					className={cf(s.wMax, s.flex, s.flexLeft, a.rememberToForget, s.p5)}
				>
					<span className={cf(s.wMax, s.dInlineBlock, s.tLeft, a.notice)}>
						The information provided would be saved securely as per our&nbsp;
						<Link
							to={'https://cribvest.com/terms-and-conditions/'}
							className={cf(s.link)}
						>
							Terms of Service
						</Link>
						&nbsp;&&nbsp;
						<Link
							to={'https://cribvest.com/privacy-policy/'}
							className={cf(s.link)}
						>
							Privacy Policy
						</Link>
					</span>
				</div>
			</form>

			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='482'
				height='2'
				viewBox='0 0 482 2'
				fill='none'
				className={cf(s.wMax, a.strike)}
			>
				<path
					d='M0 1H482'
					stroke='#B2B2B2'
					strokeWidth='0.5'
				/>
			</svg>

			<span className={cf(s.wMax, s.flex, s.flexCenter, s.tCenter, a.instead)}>
				Already have an account?&nbsp;
				<Link
					to={'/account/login'}
					className={cf(s.flex, a.alt)}
				>
					Sign In
				</Link>
			</span>
		</div>
	)
}

export default UpdateUser
